module.exports = __webpack_public_path__ + "img/滇鸡血藤.a97d251f.jpg";